import type { FaireProductEntity } from "../../entity_types/product";

export const p_9dzxk3jqdk: FaireProductEntity = {
  token: "p_9dzxk3jqdk",
  type: "product",
  name: "Baby Organic Knotted Gown + Top Knot Hat | Navy Blue",
  brandToken: "b_a1kpo4g3o4",
  brandName: "Fawn & Foster",
  imageUrl:
    "https://cdn.faire.com/fastly/0ad58bc5e9735cc62a86786b96379a4e506505757c82fdd74c923203aab83d1a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/fcfe9a286ec1f53c24a35b0b6d206b4bc73c3fe7ece3a06acd3b755f272f75a5.png",
    "https://cdn.faire.com/fastly/b1661d950e0eadb87fc95e366f2379a1861791b540d4c44b6671e7ed274acef7.webp",
    "https://cdn.faire.com/fastly/ee6c2924a092694b941a783e6d68fe9efd4955ed6bc8b632228a30a90f15f943.jpeg",
    "https://cdn.faire.com/fastly/aab5e8348e96de300afd120804e25f28bab5a261c4e47229aaf519829e9836e2.webp",
    "https://cdn.faire.com/fastly/e4a1812f8adab55760ddbf82739894678ce77c9878c497673e73063d60f2f3da.webp",
    "https://cdn.faire.com/fastly/66dd957e7338ae431eb8a6ac696eafecb0a1f762cd4c549acc6c6967f2ca644a.jpeg",
    "https://cdn.faire.com/fastly/75047477104e132af7e40dd9cb802e11b3552e3c06baf2b3c1bdcab015ce256a.jpeg",
  ],
  priceDollars: 7.5,
  description:
    "SUPER SOFT:  Certified organic cotton with 5% spandex for the perfect fit + stretch🌿\n\nEASY TO USE:  Simply open buttons at neckline and slide gown from baby’s feet up to shoulders, then insert baby’s arms.  Sleepwear, meant to fit snug. Features fold over sleeves to tuck in baby's hands.\n\nPERFECT ANNOUNCEMENT + COMING HOME OUTFIT❤\n\nCONTENTS:  One knotted gown + top knot hat. \n\nVERSATILE:  Endless mixing and matching with our organic swaddles + headbands!\n\nSIZE:  Newborn - 3 months.  Fits 0-15 lbs. approximately.\n\nBEAUTIFUL GIFT:  All Fawn & Foster products arrive in gorgeous, minimal packaging. Our mission of donating a portion of proceeds to helping foster children & other children in-need is stated on every package, so you feel confident in your purchase whether for yourself or as a gift. Thank you for your love and support of our mission to help these sweet children 🎁",
  tags: [],
  msrpDollars: 34.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:52.381Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
